import { NoWrap, numberFormat } from "../../../../utils/helpers";
import { INCIDENT_TICKET_SEVERITY_REPORT } from "../../../../utils/apis";

export const useIncidentTicketSeverityReport = () => {
  return {
    reportTitle: "Incident Ticket Severity Report",

    customApi: () => INCIDENT_TICKET_SEVERITY_REPORT,

    tableData: (results: any[]) => {
      return results.map((item: any) => ({
        ...item,
        month_name: <NoWrap>{item.month_name || item.date}</NoWrap>,
        total_tickets: numberFormat(item.total_tickets || "0"),
      }));
    },

    tableColumns: () => [
      { id: "month_name", header: "Month" },
      { id: "severity", header: "Severity" },
      { id: "open_tickets", header: "Open Tickets" },
      { id: "closed_tickets", header: "Closed Tickets" },
      { id: "resolved_tickets", header: "Resolved Tickets" },
    ],

    graphData: (results: any[]) => {
      if (!results.length) return { xLabels: [], series: [], yLabel: "" };

      const xLabels = results.map(
        (item) => item.category_name || item.month_name || "",
      );
      const series = [
        {
          name: "Total Tickets",
          data: results.map((item) => Number(item.total_tickets || 0)),
        },
      ];

      return {
        xLabels,
        series,
        yLabel: "Total Tickets",
      };
    },

    externalFilters: [],

    initialFilters: {},

    exportData: {
      getEndpoint: () => `${INCIDENT_TICKET_SEVERITY_REPORT}export-to-csv`,
      fileName: "incident-ticket-severity-report.xlsx",
      buttonText: "Export CSV",
    },

    showReportTypeFilter: false,
    showTotalTypeFilter: false,
    showMonthFilter: true,
    showYearFilter: true,
    defaultReportType: "monthly",
    defaultTotalType: undefined,
  };
};
